import { Router, NavigationEnd } from "@angular/router";
import { DOCUMENT } from "@angular/common";
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  HostListener,
  OnDestroy,
} from "@angular/core";
// import { ROUTES } from "./sidebar-items";
import { AuthService } from "src/app/core/service/auth.service";
import { Role } from "src/app/core/models/role";

import { TokenCookieService } from "src/app/core/service/token-storage-cookies.service";
import { NotificationService } from "src/app/erp-procurement/data/services/notification.service";
import {
  AdminModule,
  BudgetModule,
  FinanceModule,
  FixedAssetsModule,
  HumanResourceModule,
  HumanResourceSelfServiceModule,
  ImprestModule,
  InventoryModule,
  PrepaymentModule,
  ProcurementModule,
  SuppliersManagementModule,
} from "./sidebar-items";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.sass"],
})
export class SidebarComponent implements OnInit, OnDestroy {
  public sidebarItems: any[];
  level1Menu = "";
  level2Menu = "";
  level3Menu = "";
  public innerHeight: any;
  public bodyTag: any;
  listMaxHeight: string;
  listMaxWidth: string;
  userFullName: string;
  userImg: string;
  userType: string;
  headerHeight = 60;
  currentRoute: string;
  routerObj = null;

  currentUser: any;

  userName = "";
  userRole = "";

  // private myPrivileges = privileges;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private authService: AuthService,
    // private tokenStorageService: TokenStorageService,
    private tokenCookieService: TokenCookieService,
    private router: Router,
    private notificationService: NotificationService,

  ) {
    this.currentUser = this.tokenCookieService.getUser();

    this.getProfileImage();
    // Get reference to the closest 'body' element from the current element
    const body = this.elementRef.nativeElement.closest("body");

    // Subscribe to router events
    this.routerObj = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Define the roles that should have specific menu behavior
        // const role = ["ROLE_ADMIN", "ROLE_CLERK"];

        // // Extract the current URL and split it to get the necessary parts
        // const currenturl = event.url.split("?")[0];
        // const firstString = currenturl.split("/").slice(1)[0];

        // // Determine the menu levels based on the URL and role
        // if (role.indexOf(firstString) !== -1) {
        //   // If the first part of the URL is in the role list, set level1Menu and level2Menu accordingly
        //   this.level1Menu = event.url.split("/")[2];
        //   this.level2Menu = event.url.split("/")[3];
        // } else {
        //   // Otherwise, set level1Menu and level2Menu based on different URL parts
        //   this.level1Menu = event.url.split("/")[1];
        //   this.level2Menu = event.url.split("/")[2];
        // }

        // Close the sidebar on mobile screens after menu selection
        this.renderer.removeClass(this.document.body, "overlay-open");
      }
    });

  }
  @HostListener("window:resize", ["$event"])
  windowResizecall(event) {
    this.setMenuHeight();
    this.checkStatuForResize(false);
  }
  @HostListener("document:mousedown", ["$event"])
  onGlobalClick(event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.renderer.removeClass(this.document.body, "overlay-open");
    }
  }
  // callLevel1Toggle(event: any, element: any) {
  //   if (element === this.level1Menu) {
  //     this.level1Menu = "0";
  //   } else {
  //     this.level1Menu = element;
  //   }
  //   const hasClass = event.target.classList.contains("toggled");
  //   if (hasClass) {
  //     this.renderer.removeClass(event.target, "toggled");
  //   } else {
  //     this.renderer.addClass(event.target, "toggled");
  //   }
  // }
  callLevel1Toggle(event: any, element: any) {
    if (element === this.level1Menu) {
      // Toggle the parent item only if it's already open
      this.level1Menu = "0";
    } else {
      // Set the new parent item and ensure it's open
      this.level1Menu = element;
      this.level2Menu = ""; // Reset level2Menu when switching parent
      this.level3Menu = ""; // Reset level3Menu when switching parent
    }
    const hasClass = event.target.classList.contains("toggled");
    if (hasClass) {
      this.renderer.removeClass(event.target, "toggled");
    } else {
      this.renderer.addClass(event.target, "toggled");
    }
  }

  // callLevel2Toggle(event: any, element: any) {
  //   if (element === this.level2Menu) {
  //     this.level2Menu = "0";
  //   } else {
  //     this.level2Menu = element;
  //   }
  // }
  callLevel2Toggle(event: any, element: any) {
    if (element === this.level2Menu) {
      this.level2Menu = "0";
    } else {
      this.level2Menu = element;
      this.level3Menu = ""; // Reset level3Menu when switching submenu
    }
  }

  // callLevel3Toggle(event: any, element: any) {
  //   if (element === this.level3Menu) {
  //     this.level3Menu = "0";
  //   } else {
  //     this.level3Menu = element;
  //   }
  // }
  callLevel3Toggle(event: any, element: any) {
    if (element === this.level3Menu) {
      this.level3Menu = "0";
    } else {
      this.level3Menu = element;
    }
  }


  privileges: any[] = [];

  ngOnInit() {
    // const role = this.currentUser.roles[0];

    if (this.currentUser) {
      console.log("this.currentUser:::: ", this.currentUser);
      this.userName = this.currentUser.username;
      this.userRole = this.currentUser.role.name;
      // const userRole = this.currentUser.roles[0];
      this.userFullName = this.currentUser.username;
      this.userImg = "assets/images/user/profile_img.png";

      console.log("this.currentUser : ", this.currentUser);

      const userId = this.currentUser.id;
      const module = JSON.parse(
        localStorage.getItem(`selectedModule_${userId}`) || "{}"
      );

      if (module) {
        console.log("this.module : ", module);

        if (module === "EmployeeSelfServiceModule") {
          this.sidebarItems = HumanResourceSelfServiceModule;
        } else {
          const selectedModule = this.currentUser.role.clients.find(
            (client) => client.name === module
          );
          console.log("this.selectedModule : ", selectedModule);

          if (selectedModule) {
            const moduleMapping = {
              AdminModule: AdminModule,
              ProcurementModule: ProcurementModule,
              HumanResourceModule: HumanResourceModule,
              EmployeeSelfServiceModule: HumanResourceSelfServiceModule,
              FinanceModule: FinanceModule,
              FixedAssetsModule: FixedAssetsModule,
              SuppliersManagementModule: SuppliersManagementModule,
              BudgetModule: BudgetModule,
              ImprestModule: ImprestModule,
              PrepaymentModule: PrepaymentModule,
              InventoryModule: InventoryModule,
            };

            if (module in moduleMapping) {
              const modulePrivileges = selectedModule.privileges;
              this.sidebarItems = moduleMapping[module].filter((route) => {
                const isRouteVisible = route.privilege.some((privilege) =>
                  modulePrivileges.includes(privilege)
                );
                if (!isRouteVisible) {
                  return false;
                }
                if (route.submenu.length === 0) {
                  return true;
                }
                route.submenu = route.submenu.filter((submenu) =>
                  submenu.privilege.some((privilege) =>
                    modulePrivileges.includes(privilege)
                  )
                );
                return route.submenu.length > 0;
              });
            } else {
              this.notificationService.alertWarning(
                "No sidebar items available for this module...!!"
              );
            }
          } else {
            this.notificationService.alertWarning("Invalid module selected...!!");
          }
        }
      }

    }

    // this.sidebarItems = ROUTES.filter((sidebarItem) => sidebarItem);
    this.initLeftSidebar();
    this.bodyTag = this.document.body;
  }
  ngOnDestroy() {
    this.routerObj.unsubscribe();
  }
  initLeftSidebar() {
    const _this = this;
    // Set menu height
    _this.setMenuHeight();
    _this.checkStatuForResize(true);
  }
  setMenuHeight() {
    this.innerHeight = window.innerHeight;
    const height = this.innerHeight - this.headerHeight;
    this.listMaxHeight = height + "";
    this.listMaxWidth = "500px";
  }
  isOpen() {
    return this.bodyTag.classList.contains("overlay-open");
  }
  checkStatuForResize(firstTime) {
    if (window.innerWidth < 1170) {
      this.renderer.addClass(this.document.body, "ls-closed");
    } else {
      this.renderer.removeClass(this.document.body, "ls-closed");
    }
  }
  mouseHover(e) {
    const body = this.elementRef.nativeElement.closest("body");
    if (body.classList.contains("submenu-closed")) {
      this.renderer.addClass(this.document.body, "side-closed-hover");
      this.renderer.removeClass(this.document.body, "submenu-closed");
    }
  }
  mouseOut(e) {
    const body = this.elementRef.nativeElement.closest("body");
    if (body.classList.contains("side-closed-hover")) {
      this.renderer.removeClass(this.document.body, "side-closed-hover");
      this.renderer.addClass(this.document.body, "submenu-closed");
    }
  }

  profileImage: string | ArrayBuffer | null = null;

  getProfileImage() {
    let params = {
      empPf: this.currentUser.empPfNo,
    };
    this.authService.getUserProfileImage(params).subscribe(
      (res) => {
        //this.snackbar.showNotification("snackbar-success", res.message);

        // console.log("getProfileImage res: ", res);
        if (res.entity && res.entity.imageFile) {
          this.profileImage = res.entity.imageFile;
        }
      },
      (err) => {
        console.log(err);

        // this.snackbar.showNotification("snackbar-danger", err.message);
      }
    );
  }

  // logout(): void {
  //   this.router.navigate(["/authentication/signin"]);
  // }

  logout(): void {

    console.log("this.currentUser : ", this.tokenCookieService.getUser().refreshToken)
    this.tokenCookieService
      .signOut(this.currentUser.refreshToken)
      .subscribe(
        (res) => {
          console.log("res: ", res);
          if (res.body.statusCode === 200) {
            this.router.navigate(["/authentication/signin"]);
            this.notificationService.alertSuccess(res.body.message);
          } else {
            this.notificationService.alertWarning(res.message);
            this.router.navigate(["/authentication/signin"]);
          }
        },
        (err) => {
          console.log("ERR: ", err);
          this.router.navigate(["/authentication/signin"]);
          this.notificationService.alertWarning(err.message);
        }
      );
  }
}
